import React from 'react'
import { Image } from 'semantic-ui-react'
import AuthFooter from 'components/Auth/AuthFooter'
import { mergeStyles } from '@enlyt/helpers/mergeStyles'
import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'

const HeroFamily = '/media/images/custom/images/login/eh-login@2x.png'
const LogoImage = '/media/images/custom/images/logo/eh-logo@3x.png'

const AuthTemplateHorizontal = props => {
  const { theme } = useTheme()
  const defaultStyles = themeStyles(theme)
  const styles = mergeStyles(defaultStyles, props.style)
  return (
    <div style={styles.container}>
      <div style={styles.leftContainer}>
        <div
          style={{ ...styles.childContainer, ...styles.childContainerHorizon }}
        >
          {props.children}
        </div>
        <AuthFooter style={styles.footer} />
      </div>
      <div style={styles.rightContainer}>
        <div style={styles.heroImageContainer}>
          <Image alt={'CHOC'} src={HeroFamily} fluid style={styles.heroImage} />
        </div>
        <Image src={LogoImage} alt='Enlyt Health logo' style={styles.logo} />
      </div>
    </div>
  )
}

export default AuthTemplateHorizontal
